var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCashOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25686_15595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 29,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6844 13.8578C22.4574 13.8578 18.2194 9.61997 18.2194 4.39313C18.2194 3.94796 18.254 3.51185 18.3155 3.08362C18.3504 2.84006 18.193 2.60655 17.9502 2.56704C17.2138 2.44724 16.4596 2.38086 15.6909 2.38086C7.87576 2.38086 1.51953 8.73839 1.51953 16.5518C1.51953 24.3652 7.87576 30.7227 15.6909 30.7227C23.5046 30.7227 29.8623 24.3652 29.8623 16.5518C29.8623 15.7178 29.7888 14.9008 29.6491 14.1062C29.6066 13.8641 29.3709 13.7101 29.1279 13.7474C28.6571 13.8196 28.1755 13.8578 27.6844 13.8578Z",
    fill: "url(#paint0_linear_25686_15595)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25686_15595)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25686_15595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.33594,
    y: 1.33301,
    width: 32,
    height: 30.6667,
    opacity: 0.2,
    fill: "#1080FF"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_25686_15595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 1,
    width: 21,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8223 9.7666C15.4398 9.7666 15.9414 10.2682 15.9414 10.8857V11.5439H17.5342C18.1517 11.5439 18.6533 12.0446 18.6533 12.6621C18.6533 13.2796 18.1518 13.7812 17.5342 13.7812H13.6191C13.0732 13.7812 12.6279 14.2212 12.6279 14.7656C12.628 15.316 13.0732 15.7646 13.6191 15.7646H16.0283C17.8077 15.7649 19.2559 17.2094 19.2559 18.9873C19.2556 20.7621 17.8076 22.2068 16.0283 22.207H15.9414V22.8643C15.9411 23.4816 15.4397 23.9824 14.8223 23.9824C14.205 23.9823 13.7044 23.4815 13.7041 22.8643V22.207H12.1123C11.4948 22.207 10.9933 21.7063 10.9932 21.0889C10.9932 20.4713 11.4947 19.9697 12.1123 19.9697H16.0283C16.574 19.9695 17.0183 19.5285 17.0186 18.9873C17.0186 18.4445 16.5741 18.0022 16.0283 18.002H13.6191C11.838 18.002 10.3907 16.5496 10.3906 14.7656C10.3906 12.9876 11.838 11.5439 13.6191 11.5439H13.7041V10.8857C13.7041 10.2683 14.2048 9.76676 14.8223 9.7666ZM29.3711 1.52637C29.5142 1.52639 29.6559 1.55426 29.79 1.60938C30.063 1.72274 30.2812 1.94089 30.3945 2.21387C30.4511 2.35094 30.4804 2.49559 30.4805 2.6416V6.96973C30.4803 7.58702 29.9796 8.08769 29.3623 8.08789C28.7448 8.08789 28.2433 7.58715 28.2432 6.96973V5.34668L24.3271 9.2666C24.1079 9.48432 23.8215 9.59375 23.5352 9.59375C23.2489 9.59372 22.9629 9.48421 22.7451 9.2666C22.308 8.83103 22.3076 8.12066 22.7432 7.68359L26.6621 3.76074H25.0459C24.4285 3.76048 23.9277 3.25899 23.9277 2.6416C23.928 2.02443 24.4287 1.5237 25.0459 1.52344H29.3623L29.3711 1.52637Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_25686_15595)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_25686_15595)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.39844,
    y: -0.0908203,
    width: 25.4446,
    height: 25.4446,
    opacity: 0.8,
    fill: "#1080FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25686_15595",
    x1: 1.51953,
    y1: 2.38086,
    x2: 1.51953,
    y2: 30.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25686_15595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.6667,
    fill: "white",
    transform: "translate(-1.33594 1.33301)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_25686_15595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4446,
    height: 25.4446,
    fill: "white",
    transform: "translate(6.39844 -0.0908203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCashOut);
export default __webpack_public_path__ + "static/media/ic_cash_out.c617c605.svg";
export { ForwardRef as ReactComponent };